MS = window.MS || {};

(function($) {

  var $window = $(window);
  var $document = $(document);
  var $html = $('html');
  var $body = $('body');

  MS.sultrysalt_sticky_nav = {


    init: function () {

      // The main module element
      this.$element = $('.ms-ss_module__sticky-nav');

      if ( !this.$element.length ) {
        return;
      }

      // The title element
      this.$title = this.$element.find('.ms-ss_module__sticky-nav__title');

      // Initialize JS-assisted sticky behaviour
      // ONLY IF native browser sticky behaviour is not supported
      if ( !this.isStickyPositionSupported() ) {
        this.enableSticky();
      }

    },


    enableSticky: function () {

      // Create a dummy
      this.$dummy = $('<div class="ms-ss_module__sticky-nav__dummy"></div>');

      // Insert into DOM
      this.$dummy.insertAfter(this.$element);

      // Save essential metrics
      this.updateMetrics();

      // Listens to Scroll
      this.trackScroll();

      // Listen to Resize
      this.trackResize();
    },


    // Calculate and save essential metrics
    updateMetrics: function () {
      this.topOffset = this.$element.offset().top;
    },


    // Listens to scroll to determine sticky state
    trackScroll: function () {
      $window.on('scroll', this.onScroll.bind(this));
    },


    // Listen to resize to update metrics
    trackResize: function () {
      var _this = this;

      $window.on('resize', function () {
        _this.updateMetrics();
        _this.onScroll();
      });
    },


    onScroll: function () {
      // Stick only if scroll is >= the top offset.
      // i.e, The sticky element touches the top viewport
      if ( window.pageYOffset >= this.topOffset ) {
        this.stick();
      }
      // Else, reset state
      else {
        this.unstick();
      }
    },


    stick: function () {

      if ( this.fixed ) { return; }

      this.fixed = true;
      this.$element.attr('data-fixed', true);
    },


    unstick: function () {

      if ( !this.fixed ) { return; }

      this.fixed = false;
      this.$element.removeAttr('data-fixed');
    },


    // Checks for position:sticky support
    isStickyPositionSupported: function () {
      return window.getComputedStyle(this.$element[0]).position === 'sticky';
    },


    // Changes the title
    changeTitle: function (title) {
      this.$title.text(title);
    }


  };

})(jQuery);
